<template>
    <div data-testid="step-confirmEmail" class="container step-confirm-phone">
        <h1 class="container__standard-header">
            {{ $t(`${TRANSLATION_KEY}.confirmEmail`) }}
        </h1>
        <p class="container__subheader t-center t-bold">
            {{ $t(`${TRANSLATION_KEY}.confirmEmailParagraph`) }}
        </p>
        <form @submit.prevent>
            <CodeField
                v-model="formData.confirmEmailCode2"
                name="confirmEmailCode2"
                :length="6"
                :placeholder="$t(`${TRANSLATION_KEY}.confirmEmailPlaceholder`)"
                :handles-error="true"
                @update:model-value="checkLength"
            />
            <RecaptchaButton
                :action="Action.CONFIRM_EMAIL"
                :data="formData"
                data-testid="btn-confirmEmail-nextStep"
                :button-value="$t(`${TRANSLATION_KEY}.next`)"
                class="button button--submit"
                :disabled="!isValid"
            />
            <button
                type="button"
                class="fix-phone-number"
                @click="navigateBack"
            >
                {{ $t(`${TRANSLATION_KEY}.wrongPhoneOne`) }} -
                <strong
                    >{{
                        $t(`${TRANSLATION_KEY}.wrongPhoneTwo`)
                    }}
                    &raquo;</strong
                >
            </button>
        </form>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import Field from '@/components/basic/fields/Field.vue';
import RecaptchaButton from '@/components/basic/buttons/RecaptchaSubmitButton.vue';
import CodeField from '../basic/fields/CodeField.vue';
import { StepConfirmEmail } from '@/types';
import { Action } from '@/constants/ajax';

export default defineComponent({
    name: 'ConfirmEmail',
    components: {
        Field,
        RecaptchaButton,
        CodeField,
    },
    setup() {
        const store = useStore();

        const isValid = ref(false);
        const TRANSLATION_KEY = 'steps.ConfirmEmail';

        const formData = reactive<StepConfirmEmail>({
            phoneNumber: '',
            phoneNumberPrefix: '',
            confirmEmailCode2: '      ',
        });

        const phoneNumberPrefix = computed(
            () => store.state.response.phoneNumberPrefix
        );
        const phoneNumber = computed(() => store.state.response.phoneNumber);

        onMounted(() => {
            formData.phoneNumber = phoneNumber.value;
            formData.phoneNumberPrefix = phoneNumberPrefix.value;
        });

        const checkLength = () => {
            const matches = formData.confirmEmailCode2.match(/\d/g) || [];
            isValid.value = matches.length === 6;
        };

        const navigateBack = () => {
            window.history.back();
        };

        return {
            isValid,
            formData,
            Action,
            TRANSLATION_KEY,
            checkLength,
            navigateBack,
        };
    },
});
</script>

<style scoped lang="scss">
.fix-phone-number {
    margin-top: 10px;
    font-size: 11px;
    text-align: center;
    cursor: pointer;
    display: block;
    width: 100%;
    border: none;
    background: transparent;

    &:hover {
        text-decoration: underline;
    }
}
</style>
